import { createValidation } from '_metronic/helpers/crud-helper/helpers'
import { TFunction } from '_metronic/i18n/Metronici18n'
import * as Yup from 'yup'

export const gerarFaturaSchema = (t: TFunction) => {
  const v = createValidation(t)

  return Yup.object().shape({
    descricao: Yup.string().trim().max(50, v.maxField(50)).required(v.requiredField('descricao')),
    ano: Yup.object().nullable().required(v.requiredField('ano', 'select')),
    mes: Yup.object().nullable().required(v.requiredField('mes', 'select')),
    empresa: Yup.object().nullable().required(v.requiredField('empresa', 'select')),
  })
}
